import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const playerSlice = createSlice({
  initialState: {
    currentTime: 0 as number,
    duration: 0 as number,
    loop: undefined as [number, number],
    playing: false,
    speed: 1 as number,
    url: undefined as string,
  },
  name: 'player',
  reducers: {
    loop: (state, action: PayloadAction<[number, number]>) => {
      state.loop = action.payload
      return state
    },
    pause: (state) => {
      state.playing = false
      return state
    },
    play: (state) => {
      state.playing = true
      return state
    },
    seek: (state, action: PayloadAction<number>) => {
      state.currentTime = action.payload
      return state
    },
    setSpeed: (state, action: PayloadAction<number>) => {
      state.speed = action.payload
      return state
    },
    setUrl: (state, action: PayloadAction<{ url: string; duration: number }>) => {
      return {
        currentTime: 0,
        duration: action.payload.duration,
        loop: undefined,
        playing: false,
        speed: 1,
        url: action.payload.url,
      }
    },
  },
})

export const { play, pause, setUrl, loop, seek, setSpeed } = playerSlice.actions
